<template>
    <v-container class="mb-6">

        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

        <v-card class="elevation-2 mt-5 mb-8">
            <v-card-title class="flex-nowrap">
                {{ $t('Filtrar por fechas') }}
            </v-card-title>
            <v-card-text>
                <form @submit.prevent="processSearch">
                    <v-row align="center">
                        <v-col cols="12" sm="6">
                            <v-menu
                                ref="menuInit"
                                v-model="menuInit"
                                :close-on-content-click="false"
                                :return-value.sync="dateInit"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="dateInit"
                                    :label="$t('Fecha inicial')"
                                    prepend-inner-icon="mdi-calendar"
                                    outlined
                                    dense
                                    hide-details
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="dateInit"
                                    no-title
                                    scrollable
                                    locale="es"
                                    color="primary"
                                    class="ma-0"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="red"
                                        @click="menuInit = false"
                                    >
                                        {{ $t('Cancelar') }}
                                    </v-btn>
                                    <v-btn
                                        color="primary"
                                        @click="$refs.menuInit.save(dateInit)"
                                    >
                                        {{ $t('Aceptar') }}
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-menu
                                ref="menuEnd"
                                v-model="menuEnd"
                                :close-on-content-click="false"
                                :return-value.sync="dateEnd"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="dateEnd"
                                    :label="$t('Fecha final')"
                                    prepend-inner-icon="mdi-calendar"
                                    outlined
                                    dense
                                    hide-details
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="dateEnd"
                                    no-title
                                    scrollable
                                    locale="es"
                                    color="primary"
                                    class="ma-0"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="red"
                                        @click="menuEnd = false"
                                    >
                                        {{ $t('Cancelar') }}
                                    </v-btn>
                                    <v-btn
                                        color="primary"
                                        @click="$refs.menuEnd.save(dateEnd)"
                                    >
                                        {{ $t('Aceptar') }}
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <div class="text-right mt-8">
                        <v-btn
                            class="text-capitalize mb-2 mb-sm-0 mr-2"
                            :href="`/admin/export-orders?search=${txtSearch}&states=${JSON.stringify(txtState)}&date_init=${dateInit}&date_end=${dateEnd}`"
                        >
                            <v-icon class="mr-2" color="green">mdi-file-excel</v-icon>
                            {{ $t('Exportar') }}
                        </v-btn>

                        <v-btn
                            class="text-capitalize mr-2"
                            color="primary"
                            @click="dialogMap = true"
                        >
                            <v-icon>mdi-store-marker</v-icon>
                            {{ $t('Ver mapa') }}
                        </v-btn>

                        <v-btn
                            color="primary"
                            type="submit"
                        >
                            {{ $t('Buscar') }}
                        </v-btn>
                        <v-btn
                            color="red"
                            text
                            v-show="(txtSearch !== '') || (txtState.length>0) || (dateInit!='') || (dateEnd!='')"
                            @click="cleanSearch"
                        >
                            {{ $t('Limpiar') }}
                        </v-btn>
                    </div>
                </form>
            </v-card-text>
        </v-card>

        <!-- card main -->
        <v-card class="elevation-2 mt-5">
            <v-card-title class="blue-grey darken-4 white--text">
                {{ $t('Lista de Ventas digitales') }}
                <v-spacer></v-spacer>
                <v-btn @click="scroll_left" fab small>
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn @click="scroll_right" fab small>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </v-card-title>

            <v-simple-table>
                <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>{{ $t('Número') }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='number', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='number', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtNumber"
                                                    label="Número"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('number')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            {{ $t('Acciones') }}
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>{{ $t('Estado') }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='state', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='state', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-select
                                                    v-model="txtState"
                                                    :items="itemsStatus"
                                                    item-text="label"
                                                    item-value="val"
                                                    label="Estados"
                                                    multiple
                                                    chips
                                                    outlined
                                                    hide-details
                                                    dense
                                                >
                                                    <template v-slot:selection="data">
                                                        <v-chip
                                                            :color="data.item.color"
                                                            small
                                                            class="white--text"
                                                        >
                                                            {{ data.item.label }}
                                                        </v-chip>
                                                    </template>
                                                </v-select>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('state')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left" style="min-width:150px">
                            <div class="d-flex align-center">
                                <span>{{ $t('Fecha') }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='created_at', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='created_at', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtFecha"
                                                    label="Fecha"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="date"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('fecha')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>{{ $t('Cliente') }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='full_name', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='full_name', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtSearch"
                                                    label="Cliente"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('txt')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>{{ $t('Celular') }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='phone_number', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='phone_number', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtPhone"
                                                    label="Celular"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('phone')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>{{ $t('Correo electrónico') }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='email', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='email', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtEmail"
                                                    label="Correo electrónico"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('email')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left" style="min-width:130px">
                            <div class="d-flex align-center">
                                <span>{{ $t('Forma de entrega') }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='delivery_method', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='delivery_method', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-select
                                                    v-model="txtDelivery"
                                                    :items="itemsDelivery"
                                                    item-text="label"
                                                    item-value="val"
                                                    label="Forma de entrega"
                                                    multiple
                                                    chips
                                                    outlined
                                                    hide-details
                                                    dense
                                                >
                                                    <template v-slot:selection="data">
                                                        <v-chip
                                                            small
                                                        >
                                                            {{ data.item.label }}
                                                        </v-chip>
                                                    </template>
                                                </v-select>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('delivery')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left" style="min-width:115px">
                            <div class="d-flex align-center">
                                <span>{{ $t('Recibir la orden') }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='receive_order', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='receive_order', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-select
                                                    v-model="txtRebicir"
                                                    :items="itemsRecibir"
                                                    item-text="label"
                                                    item-value="val"
                                                    label="Modo de recibir la orden"
                                                    outlined
                                                    hide-details
                                                    dense
                                                ></v-select>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('recibir')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left" style="min-width:200px">
                            <div class="d-flex align-center">
                                <span>{{ $t('Dirección de recojo') }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='delivery_address', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='delivery_address', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtAddress"
                                                    label="Dirección"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('address')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left" style="min-width:160px">
                            <div class="d-flex align-center">
                                <span>{{ $t('Método de pago') }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='payment_method', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='payment_method', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-select
                                                    v-model="txtMetodo"
                                                    :items="[ {label: 'Pago Contraentrega', val: 'cash_payment'}, {label: 'Pago Qr/Transferencia Bancaria', val: 'bank_payment'}, {label: 'Pago tarjeta de débito/crédito', val: 'card_payment'}, {label: 'Pago por PagomóvilBDV', val: 'bank_ven'} ]"
                                                    item-text="label"
                                                    item-value="val"
                                                    label="Método de pago"
                                                    outlined
                                                    hide-details
                                                    dense
                                                ></v-select>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('metodo')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left blue-grey lighten-4" style="min-width:200px" v-for="(art, j) in maxProds" :key="j">
                            Artículo {{ j+1 }}
                        </th>
                        <th class="text-left" style="min-width:160px">
                            <div class="d-flex align-center">
                                <span>{{ $t('Cupón') }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='coupon', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='coupon', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtCupon"
                                                    label="Cupón"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('cupon')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left" style="min-width:160px">
                            <div class="d-flex align-center">
                                <span>{{ $t('Comer en mesa') }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='eat_local', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='eat_local', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtComerEnMesa"
                                                    label="Total"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="number"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('comerenmesa')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left" style="min-width:160px">
                            <div class="d-flex align-center">
                                <span>{{ $t('Descuento por recojo') }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='pickup_discount', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='pickup_discount', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>
                            </div>
                        </th>
                        <th class="text-right" style="min-width:100px">
                            <div class="d-flex align-center">
                                <span>{{ $t('Total') }} {{ money }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='total', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden descendente') }}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='total', getListOrders()"
                                            ></span>
                                        </template>
                                        <span>{{ $t('Orden ascendente') }}</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtTotal"
                                                    :label="$t('Total')"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="number"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('total')"
                                                    >
                                                        {{ $t('Limpiar') }}
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>

                        <th v-if="view_cost_revenue === '1'" style="min-width: 100px;">
                            <div class="text-end">
                                {{ $t('Costo total') }} {{ money }}
                            </div>
                        </th>
                        <th v-if="view_cost_revenue === '1'" style="min-width: 100px;">
                            <div class="text-end">
                                {{ $t('Ganancia') }} {{ money }}
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in listOrders" :key="index">
                        <td>{{ item.number }}</td>
                        <td>
                            <div class="d-flex">
                                <v-tooltip top v-if="typeStore === 'none'">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            icon
                                            :href="`/admin/order/${item.id}`"
                                        >
                                            <v-icon color="grey">
                                                mdi-eye
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('Ver') }}</span>
                                </v-tooltip>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            icon
                                            :href="`/admin/print-order/${item.id}`"
                                            target="_blank"
                                        >
                                            <v-icon color="grey">
                                                mdi-file-document-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('Ver recibo') }}</span>
                                </v-tooltip>
                                <v-tooltip top v-if="typeStore === 'none'">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            icon
                                            @click="printOrder(item.id)"
                                        >
                                            <v-icon color="grey">
                                                mdi-printer
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('Imprimir') }}</span>
                                </v-tooltip>
                                <v-tooltip top v-if="item.delivery_method=='none'">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            icon
                                            :href="`/admin/print-order-qr/${item.id}`"
                                            target="_blank"
                                        >
                                            <v-icon color="grey">
                                                mdi-moped
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('Delivery') }}</span>
                                </v-tooltip>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            icon
                                            :href="`/admin/print-internalorder/c/${item.id}`"
                                            target="_blank"
                                        >
                                            <!-- @click="internalSaleId = item.id, dialogPrintInvoice = !dialogPrintInvoice" -->
                                            <v-icon color="grey">
                                                mdi-file-document-alert-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('Ver comanda') }}</span>
                                </v-tooltip>
                            </div>
                        </td>
                        <td>
                            <div>
                                <span
                                    class="green--text"
                                    v-if="item.state === 'Completado'"
                                >
                                    Completado
                                </span>

                                <span
                                    class="red--text"
                                    v-if="item.state === 'Fallido'"
                                >
                                    Fallido
                                </span>
                                <span
                                    class="deep-orange--text"
                                    v-if="item.state === 'Reembolsado'"
                                >
                                    Reembolsado
                                </span>

                                <v-select
                                    :items="itemsStates"
                                    label="Estado"
                                    outlined
                                    dense
                                    hide-details
                                    v-model="item.state"
                                    v-if="item.state !== 'Fallido' && item.state !== 'Reembolsado' && item.state !== 'Completado'"
                                    @change="updateState(item.state, item.id)"
                                >
                                    <template v-slot:selection="data">
                                        <span :class="{
                                            'primary--text': data.item=='Nuevo',
                                            'green--text': data.item=='Completado',
                                            'blue--text': data.item=='Pendiente',
                                            'red--text': data.item=='Fallido',
                                            'deep-orange--text': data.item=='Reembolsado',
                                        }">
                                            {{ data.item }}
                                        </span>
                                    </template>
                                </v-select>
                            </div>
                        </td>
                        <td>{{ item.date }}</td>
                        <td>{{ item.full_name }}</td>
                        <td>{{ item.phone_number }}</td>
                        <td>{{ item.email ? (item.email != 'null' ? item.email : '-') : '-' }}</td>
                        <td>
                            <span v-if="item.delivery_method=='i_pick_up'">{{ $t('Recojo') }}</span>
                            <span v-if="item.delivery_method=='delivery'">{{ $t('Delivery') }}</span>
                            <span v-if="item.delivery_method=='order_table'">{{ $t('Pedido en mesa') }}</span>
                        </td>
                        <td>
                            <div v-if="item.receive_order=='schedule_delivery'">
                                {{ $t('Programar entrega') }}: {{ item.order_day }} {{ item.order_time }}
                            </div>
                            <div v-else>
                                {{ $t('Ahora mismo') }}
                            </div>
                        </td>
                        <td>
                            <div v-if="item.delivery_method!='order_table'">
                                <div v-if="item.delivery_method=='i_pick_up'">
                                    {{ $t('Dirección de recojo') }}: {{ item.address_of_pickUp }}
                                </div>
                                <div>
                                    {{ $t('Dirección de entrega') }}: {{ item.delivery_address }}, {{ item.address_clarification }}
                                </div>
                            </div>
                        </td>
                        <td>
                            <div v-if="item.payment_method=='cash_payment'">{{ $t('Pago Contraentrega') }}</div>
                            <div v-if="item.payment_method=='bank_payment'">{{ $t('Pago Qr/Transferencia Bancaria') }}</div>
                            <div v-if="item.payment_method=='card_payment'">{{ $t('Pago tarjeta de débito/crédito') }}</div>
                            <div v-if="item.payment_method=='bank_ven'">{{ $t('Pago por PagomóvilBDV') }}</div>
                        </td>
                        <template v-for="(article, i) in item.products">
                        <td class="blue-grey lighten-4" :key="i+'one'">
                            {{ article.name }} x{{ article.pivot.quantity }} {{ money }} {{ article.price }} - {{ article.pivot.extra }}
                        </td>
                        </template>
                        <template v-for="(temp, j) in (maxProds -item.products.length)">
                        <td class="blue-grey lighten-4" :key="j+'two'">-</td>
                        </template>
                        <td class="text-left">
                            {{ item.coupon }}
                        </td>
                        <td class="text-left">
                            {{ item.eat_local }}
                        </td>
                        <td class="text-left">
                            <span v-if="item.delivery_method=='i_pick_up' && item.pickup_discount>0">{{ item.pickup_discount }}</span>
                        </td>
                        <td class="text-right">
                            {{ ((item.total-item.discount)>0)? ( (item.total-item.discount) - ((item.eat_local)?item.eat_local:0) - ((item.pickup_discount)?item.pickup_discount:0) ) :0 }}
                        </td>

                        <td v-if="view_cost_revenue === '1'" >
                            <div class="text-end">
                                {{ item.suplies_cost }}
                            </div>
                        </td>
                        <td v-if="view_cost_revenue === '1'" >
                            <div class="text-end">
                                {{ item.revenue }}
                            </div>
                        </td>
                    </tr>
                </tbody>
                </template>
            </v-simple-table>
        </v-card>
        <div class="text-right py-2" v-html="pageTable"></div>
        <v-pagination
            v-model="page"
            :length="totalPage"
            :total-visible="5"
            color="primary"
            @input="changePage"
            class="my-5"
        ></v-pagination>
        <!-- end card main -->

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->

        <v-dialog
            v-model="dialogMap"
            max-width="1400"
        >
            <v-card>
                <v-card-title class="text-h5">
                    {{ $t('Mapa de pedidos delivery') }}
                </v-card-title>
                <v-card-text>
                    <orders-map v-if="dialogMap" :date-init="dateInit" :date-end="dateEnd" />
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        text
                        @click="dialogMap = false"
                    >
                        {{ $t('Cerrar') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- dialog cash -->
        <v-dialog
            v-model="dialogPrintInvoice"
            persistent
            max-width="350"
        >
            <v-card>
                <v-card-title></v-card-title>
                <v-card-text>
                    <v-btn
                        color="primary"
                        block
                        x-large
                        target="_blank"
                        class="mb-4"
                        :href="`/admin/print-internalorder/r/${internalSaleId}`"
                    >{{ $t('Imprimir Recibo') }}</v-btn>
                    <v-btn
                        color="primary"
                        block
                        x-large
                        target="_blank"
                        :href="`/admin/print-internalorder/c/${internalSaleId}`"
                    >{{ $t('Imprimir Comanda') }}</v-btn>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        text
                        @click="dialogPrintInvoice = false"
                    >
                        {{ $t('Cerrar') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- END dialog cash -->

    </v-container>
</template>
<script>
export default {
    data() {
        return {
            overlay: false,
            loading: false,
            loading2: false,
            breadcrumbs: [
                {
                    text: 'Ventas digitales',
                    disabled: false,
                    href: '/admin/orders',
                },
                {
                    text: 'Todos',
                    disabled: true,
                    href: '',
                }
            ],
            tmpSlug: 'http://'+window.location.hostname+'/',
            // list data
            listOrders: [],
            maxProds: 0,
            pageTable: '',
            page: 1,
            totalPage: null,
            txtSearch: '',
            itemsStatus: [
                {label: 'Nuevo', val: 'Nuevo', color: 'blue'},
                {label: 'Pendiente', val: 'Pendiente', color: 'blue'},
                {label: 'Procesando', val: 'Procesando', color: 'teal'},
                {label: 'En espera', val: 'En espera', color: ''},
                {label: 'Completado', val: 'Completado', color: 'success'},
                {label: 'Cancelado', val: 'Cancelado', color: 'grey'},
                {label: 'Reembolsado', val: 'Reembolsado', color: 'deep-orange'},
                {label: 'Fallido', val: 'Fallido', color: 'error'},
            ],
            itemsDelivery: [
                {label: 'Delivery', val: 'delivery'},
                {label: 'Recojo', val: 'i_pick_up'},
                {label: 'Pedido para la mesa', val: 'order_table'},
                {label: 'Comer en nuestro local', val: 'eat_local'},
            ],
            itemsRecibir: [
                {label: 'Ahora mismo', val: 'right_now'},
                {label: 'Programar entrega', val: 'schedule_delivery'}
            ],
            txtState: [],
            txtPhone: '',
            txtEmail: '',
            txtNumber: '',
            txtDelivery: [],
            txtRebicir: '',
            txtAddress: '',
            txtMetodo: '',
            txtTotal: '',
            txtComerEnMesa: '',
            txtCupon: '',
            txtFecha: '',
            // export
            menuInit: false,
            menuEnd: false,
            dateInit: this.getFirstDayOfMonty(),
            dateEnd: this.getCurrentDate(),
            orderType: 'DESC',
            orderBy: 'created_at',
            // actualizar estados
            itemsStates: ['Nuevo', 'Pendiente', 'Completado', 'Reembolsado', 'Fallido'],
            state: '',
            dialogMap: false,
            // recibo y comanda
            dialogPrintInvoice: false,
            internalSaleId: ''
        }
    },
    props: ['money','typeStore','view_cost_revenue'],
    mounted() {
        this.getListOrders()
    },
    methods: {
        /**
         * List categories
         */
        processSearch () {
            this.page = 1
            this.getListOrders()
        },
        changePage (event) {
            this.page = event;
            this.getListOrders()
        },
        cleanSearch (type='') {
            if (type=='') {
                if ( (this.txtSearch !== '') || (this.txtState.length>0) || (this.dateInit!='') || (this.dateEnd!='') ) {
                    this.listOrders = []
                    this.page = 1
                    this.txtSearch = ''
                    this.txtState = []
                    this.dateInit = ''
                    this.dateEnd = ''
                    this.txtNumber = ''
                    this.getListOrders();
                }
            } else {
                switch (type) {
                    case 'state':
                        this.txtState = []
                        this.getListOrders();
                        break;
                    case 'txt':
                        this.txtSearch = ''
                        this.getListOrders();
                        break;
                    case 'phone':
                        this.txtPhone = ''
                        this.getListOrders();
                        break;
                    case 'email':
                        this.txtEmail = ''
                        this.getListOrders();
                        break;
                    case 'number':
                        this.txtNumber = ''
                        this.getListOrders();
                        break;
                    case 'delivery':
                        this.txtDelivery = []
                        this.getListOrders();
                        break;
                    case 'recibir':
                        this.txtRebicir = ''
                        this.getListOrders();
                        break;
                    case 'address':
                        this.txtAddress = ''
                        this.getListOrders();
                        break;
                    case 'metodo':
                        this.txtMetodo = ''
                        this.getListOrders();
                        break;
                    case 'total':
                        this.txtTotal = ''
                        this.getListOrders();
                        break;
                    case 'comerenmesa':
                        this.txtComerEnMesa = ''
                        this.getListOrders();
                        break;
                    case 'cupon':
                        this.txtCupon = ''
                        this.getListOrders();
                        break;
                    case 'fecha':
                        this.txtFecha = ''
                        this.getListOrders();
                        break;
                    default:
                        break;
                }
            }
        },
        async getListOrders () {
            this.listOrders = []
            this.overlay = true
            await axios.post(`/admin/list-orders?page=${this.page}
                            &orderby=${this.orderBy}
                            &ordertype=${this.orderType}
                            &search=${this.txtSearch}
                            &states=${JSON.stringify(this.txtState)}
                            &date_init=${this.dateInit}
                            &date_end=${this.dateEnd}
                            &phone=${this.txtPhone}
                            &email=${this.txtEmail}
                            &number=${this.txtNumber}
                            &delivery=${JSON.stringify(this.txtDelivery)}
                            &recibir=${this.txtRebicir}
                            &direccion=${this.txtAddress}
                            &metodo=${this.txtMetodo}
                            &total=${this.txtTotal}
                            &comerenmesa=${this.txtComerEnMesa}
                            &cupon=${this.txtCupon}
                            &fecha=${this.txtFecha}
                        `, {})
            .then(response => {
                // console.log(response)
                response.data[0].data.forEach(element => {
                    const d = new Date(element.created_at)
                    element.date = d.getDate() +'-'+ (d.getMonth()+1) +'-'+ d.getFullYear() +'  '+ d.getHours()+':'+d.getMinutes()
                    this.listOrders.push(element)
                });
                // this.listOrders = response.data[0].data
                this.totalPage = response.data[0].last_page
                this.pageTable = `${this.$t('Mostrando')} <strong>${response.data[0].from??0} - ${response.data[0].to??0}</strong> ${this.$t('de un total de')} <strong>${response.data[0].total}</strong>`

                this.maxProds = response.data[1]

                this.overlay = false
            })
            .catch(error => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
                this.overlay = false
            })
        },
        /**
         * scroll
         */
        scroll_left() {
        let content = document.querySelector(".v-data-table__wrapper");
            content.scrollLeft -= 100;
        },
        scroll_right() {
            let content = document.querySelector(".v-data-table__wrapper");
            content.scrollLeft += 100;
        },

        /**
         * Aceptar/rechazar
         */
        async aceptarRechazar(type, id) {
            this.loading2 = true
            await axios.post('/admin/accept-reject', {type:type, id:id})
            .then((response) => {
                // console.log(response)
                if (response.data == 'ok') {
                    this.$alert('', this.$t('Cambio de estado con éxito.'), 'success', {confirmButtonText: this.$t('Continuar')})
                    this.getListOrders()
                }
                this.loading2 = false
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
                this.loading2 = false
            })
        },

        /**
         * imprimir pdf
         */
        async printOrder(id) {
            this.loading = true
            await axios.post(`/admin/print-order2/${id}`)
            .then((response) => {
                // console.log(response)
                if (response.data.pdf) {
                    const pdfBase64 = response.data.pdf;

                    // Crea un objeto de tipo Blob a partir del base64
                    const byteCharacters = atob(pdfBase64);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: 'application/pdf' });

                    // Crea un objeto URL para el blob
                    const url = window.URL.createObjectURL(blob);

                    // Abre el diálogo de impresión del navegador para el PDF
                    const iframe = document.createElement('iframe');
                    iframe.style.display = 'none';
                    iframe.src = url;
                    document.body.appendChild(iframe);

                    iframe.onload = function() {
                        iframe.contentWindow.print();
                    };

                    // Limpia el objeto URL
                    window.URL.revokeObjectURL(url);
                }
                if (response.data.txt) {
                    // Abre el diálogo de impresión del navegador para el archivo de texto
                    const iframe = document.createElement('iframe');
                    iframe.style.display = 'none';
                    iframe.src = URL.createObjectURL(new Blob([response.data.txt], { type: 'text/plain' }));
                    document.body.appendChild(iframe);

                    iframe.onload = function() {
                        iframe.contentWindow.print();
                    };
                }

                this.loading = false
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
                this.loading = false
            })
        },

        /**
         * update state
         */
         async updateState(val, id) {
            this.loading = true
            await axios.post(`/admin/up-order/${id}`, {state: val})
            .then((response) => {
                // console.log(response);
                if (response.data === 'ok') {
                    this.$notify.success(this.$t('Estado actualizado con éxito.'))
                }
                this.loading = false
            })
            .catch((error) => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
                this.loading = false
            });

            if(val != 'Completado') { return; }

            try {
                this.loading = true;
                let {data} = await axios.post(`/admin/update-erp`, { order_id: id });
                if(data.success) {
                    this.$notify.success(this.$t('Sistema de Gestión actualizado con éxito.'))
                } else {
                    this.$alert(data.message);
                }
            } catch (error) {} finally { this.loading = false;  }
        },
        getFirstDayOfMonty() {
            const now = new Date();
            const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
            return firstDay.toISOString().split('T')[0];
        },
        getCurrentDate() {
            const now = new Date();
            return now.toISOString().split('T')[0];
        }
    },
}
</script>
